import React from 'react';
import moment from 'moment';
import FineUploaderTraditional from 'fine-uploader-wrappers';
import ServerProperties from '../config/server.js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
const haversine = require('haversine');

export default {
	MaintenaceStatus(RowData, Props){
		let clsName, txtStatus, txtTitle;
		// var date = new Date();
		if(RowData.Maintenance === null){
			clsName = 's-good'
			txtStatus = 'Good'
			txtTitle = 'status maintenance Good'
		}else{
			const ScheduledStart = moment(RowData.Maintenance.ScheduledStart);
			let diffDate = (ScheduledStart - moment()) / 1000 / 60 / 60 / 24;
			if (RowData.Maintenance.Status === 'in-progress'){
				clsName = 's-inprogress'
				txtStatus = 'In-Progress'
				txtTitle = 'status maintenance In-Progress'
			}else if(diffDate > 12){
				clsName = 's-good'
				txtStatus = 'Good'
				txtTitle = 'status maintenance Good'
			}else if(diffDate >= 4){
				clsName = 's-warning'
				txtStatus = Math.floor(diffDate) + ' days'
				txtTitle = 'status maintenance ' + Math.floor(diffDate) + ' days'
			}else if(diffDate >= 0){
				clsName = 's-danger'
				if (diffDate < 1){
					diffDate *= 24;
					txtStatus = Math.floor(diffDate) + ' hours'
					txtTitle = 'status maintenance ' + Math.floor(diffDate) + ' hours'
				}else{
					txtStatus = Math.floor(diffDate) + ' days'
					txtTitle = 'status maintenance ' + Math.floor(diffDate) + ' days'
				}
			}else if(diffDate < 0){
				clsName = 's-overdue box-blink'
				diffDate = Math.abs(diffDate)
				if (diffDate < 1){
					diffDate *= 24
					txtStatus = Math.floor(diffDate) + ' hours OD'
					txtTitle = 'status maintenance ' + Math.floor(diffDate) + ' hours overdue'
				}else{
					txtStatus = Math.floor(diffDate) + ' days OD'
					txtTitle = 'status maintenance ' + Math.floor(diffDate) + ' days overdue'
				}
			}
		}
		return (
			<strong
				onClick={((e)=>e.stopPropagation, () => Props.history.push((window.ReactNativeWebView ? "/single-page" : "/home") + '/maintenance-list/' + RowData.Alias + '/' + encodeURIComponent(RowData.Name) + '/' + RowData.Owner.Username))}
	    		title={txtTitle}
	      		className={"btn-badge " + clsName}>{txtStatus}
	    	</strong>
		)
	},
	GetCityValue(cityList, cityName){
		let isCityFound = false
		let city = {
			value : '',
			label : ''
		};
		if (cityList !== null && cityName !== ''){
		  	cityList.forEach(res => {
		    	if(res.Name.toLowerCase().includes(cityName.toLowerCase())){
		      		city.value 	= res.Alias
		      		city.label 	= res.Name
		      		isCityFound = true
		    	}
		  	});
		}
		if (cityName !== '' && isCityFound === false){
		  toast.warn("The selected city " + cityName + " is not allowed")
		}
		return city.value
	},
	SelectInMapButton(onclick){
		return(
			<div className="float-right">
				<button type="button" style={{ fontSize : 12 }} className="btn btn-sm btn-success" onClick={onclick}>
					<i className="fa fa-dot-circle-o"></i> Select in Map
				</button>
			</div>
		)
	},
	GetNearestSite(siteData, currentLocation){
		let siteCoordinate, distance = 0, nearest = 5, nearestSite = null;
		for (var i = 0; i < siteData.length; i++) {
			siteCoordinate = {
				latitude : parseFloat(siteData[i].Latitude),
				longitude : parseFloat(siteData[i].Longitude)
			}

			distance = haversine(currentLocation, siteCoordinate)

			if (distance <= nearest){
				nearestSite = siteData[i]
				nearest = distance
			}
		}
		return nearestSite
	},
	MessageEditor(msg, isSplited, toggleModalReassign = null) {
		let msgStr 		= null;
		let editedMsg 	= Object.assign({}, msg);
		let msgObj 		= JSON.parse(editedMsg.Extra)
		const splitMessage 	= function(messages, split, tag){
			const splited = messages.Content.split(split)
			messages.Content   = []
			let i 		  = 0
			for (i = 0 ; i < splited.length - 1 ; i++){
				messages.Content.push(splited[i], tag)
			}
			messages.Content.push(splited[i])
		}

		try{
			msgStr 	= msgObj.Asset.Name
						+ '(' + msgObj.Asset.Alias+ ') '
						+ 'from ' + moment(msgObj.StartDate).format('ll')
						+ ' to ' + moment(msgObj.FinishDate).format('ll')
						+ ' at ' + msgObj.Location.Name + ' in '
						+  msgObj.Site.Name
		}catch(err){}

		if(editedMsg.Type === 'booking-register'){
			editedMsg.Content = 'You have just booked ' + msgStr
		}else if(editedMsg.Type === 'booking-cancel'){
			editedMsg.Content = 'You have just canceled reservation for ' + msgStr
		}else if(editedMsg.Type === 'booking-reschedule'){
			editedMsg.Content = 'You have just rescheduled reservation for ' + msgStr
		}else if(editedMsg.Type === 'reminder-reminder'){
			if(Array.isArray(editedMsg.Content) === false){
				editedMsg.Content = editedMsg.Content.replace('[params]',
									moment(msgObj.Work.ScheduledStart).format('ll'))
				if (isSplited) splitMessage(editedMsg, '\n', <br />);
			}
		}else if(editedMsg.Type === 'booking-register-incoming-book-reminder'){
			if(Array.isArray(editedMsg.Content) === false){
				editedMsg.Content = editedMsg.Content.replace('[params]',
									moment(msgObj.StartDate).format('ll')).replace('[params]',
									moment(msgObj.FinishDate).format('ll'))
				if (isSplited) {
					splitMessage(
						editedMsg,
						'[action]',
						<a role="button"
							className="apple-blue hover-apple-blue"
							onClick = {() => toggleModalReassign(msgObj)}>Here</a>
					);
				}
			}
		}else if(editedMsg.Type === 'maintenance-request'){
			if(Array.isArray(editedMsg.Content) === false){
				editedMsg.Content = editedMsg.Content.replace('[params]',
								 	moment(msgObj.Accessed.CreatedTime).format('ll'))
				if (isSplited) splitMessage(editedMsg, '\n', <br />);
			}
		}else if(editedMsg.Type === 'maintenance-register'){
			if(Array.isArray(editedMsg.Content) === false){
				editedMsg.Content = editedMsg.Content.replace('[params]',
					 				moment(msgObj.ScheduledStart).format('ll'))
				if (isSplited) splitMessage(editedMsg, '\n', <br />);
			}
		}else if([
			'confirmation-register-to-reservation',
			'confirmation-accept-to-reservation'
			].includes(editedMsg.Type))
		{
			editedMsg.Content = editedMsg.Content.replace('[params]',
								moment(msgObj.ToReservation.StartDate).format('ll'))
		}else if([
			'confirmation-register-from-reservation',
			'confirmation-accept-from-reservation'
			].includes(editedMsg.Type))
		{
			editedMsg.Content = editedMsg.Content.replace('[params]',
								moment(msgObj.FromReservation.StartDate).format('ll'))
		}else if([
			'reminder-asset_duedate',
			'asset-extend'
			].includes(editedMsg.Type))
		{
			if(Array.isArray(editedMsg.Content) === false){
				editedMsg.Content = editedMsg.Content.replace('[params]',
									moment(msgObj.Tracking.DueDate).format('ll'))
				if (isSplited) splitMessage(editedMsg, '\n', <br />);
			}
			// console.log(editedMsg.Content)
		}else if([
			'maintenance-reject',
			'asset-move'
			].includes(editedMsg.Type))
		{
			if(Array.isArray(editedMsg.Content) === false){
				if (isSplited) splitMessage(editedMsg, '\n', <br />);
			}
		}
		return editedMsg
    },
    Uploader: function(UserReducer, AssetAliases, onsucces, onfailed){
      let imgFilesExt = ['jpeg', 'jpg', 'png', 'gif', 'img', 'ico']
      let docFilesExt = ['csv', 'doc', 'docx','docm', 'txt', 'odt', 'rtf', 'xlsx', 'xls', 'ppt', 'pptx', 'pdf', 'ini']
      const upload = new FineUploaderTraditional({
          options: {
             scaling: {
               sendOriginal: false,
               hideScaled: true,
               sizes: [
                 {name: "small", maxSize: 500},
               ]
             },
              validation: {
                acceptFiles : "application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                allowedExtensions: imgFilesExt.concat(docFilesExt),
                sizeLimit: 15000000  // bytes
              },
             request: {
                tempParams: {},
                customHeaders : {
                  "Authorization":"Bearer "+UserReducer.token,
                },
                retry: {
                  enableAuto: true
                },
                inputName:"File",
                paramsInBody:true,
                forceMultipart : true,
                endpoint: ServerProperties.ATM_CLOUD.API+"Asset/Document/Register/"
             },
             autoUpload : true,
             callbacks: {
                onComplete: function(id, name, responseJSON, xhr) {
                  onsucces(name)
                },
                onError: function(id, name, errorReason, xhrOrXdr) {
                  onfailed(errorReason)
                  console.log(errorReason)
                },
                onSubmitted: function(id, name){
                  const fileExtension = upload.qq.getExtension(name).toLowerCase()
                  let uploadParamsObj = {}
                  if (imgFilesExt.includes(fileExtension)){
                    upload.methods.setEndpoint(ServerProperties.ATM_CLOUD.API+"Asset/Photo/Upload/")
                    uploadParamsObj = {
                      AssetAlias    : upload.methods._options.request.tempParams.Asset,
                      Photo         : upload.methods.getFile(id),
                      TakenTimeStamp: moment().unix(),
                      is_tracking   : false,
                      TrackingAlias : ''
                    }
                  }else{
                    upload.methods.setEndpoint(ServerProperties.ATM_CLOUD.API+"Asset/Document/Register/")
                    uploadParamsObj = {
                      Asset    : upload.methods._options.request.tempParams.Asset,
                      File     : upload.methods.getFile(id),
                      Filename : name
                    }
                  }
                  upload.methods.setParams(uploadParamsObj)
                }
             }
          }
       })
      return upload
    }
}



// WEBPACK FOOTER //
// ./src/App/utils/Render.js